goog.provide("shadow.js.shim.module$$mui$material$ListItemButton$default");
shadow.js.shim.module$$mui$material$ListItemButton$default = shadow.js.require(484, {})["default"];
